
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/converter/xml-to-yaml",
      function () {
        return require("private-next-pages/converter/xml-to-yaml.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/converter/xml-to-yaml"])
      });
    }
  